<template>
  <div class="TopSubstation">
    <div class="TopSubstation-box">
      <div class="substation-label">分站</div>
      <div class="TopSubstation-def">
        <a :href="`/zb/area_${item.id}/`" v-for="item in list" :key="item.id">{{ item.text }}</a>
        <div class="TopSubstation-more" @click="more = !more">更多>></div>
      </div>
    </div>
    <div class="substation-more-box" v-if="more">
      <div class="substation-more-item" v-for="item in provinceList" :key="item.id">
        <span class="substation-label">{{ item.name }}</span>
        <a v-for="ite in item.children" :href="`/zb/area_${ite.id}/`" :key="ite.id">{{ ite.name }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { areaProvinceJSON } from "@/assets/areaProvinceJSON";
export default {
  name: "TopSubstation",
  data() {
    return {
      provinceList: [],
      list: [
        { text: "北京", id: "2" },
        { text: "山东", id: "21" },
        { text: "陕西", id: "23" },
        { text: "江苏", id: "15" },
        { text: "广东", id: "5" },
      ],
      more: false,
    };
  },
  created() {
    this.provinceList = areaProvinceJSON.slice(0, areaProvinceJSON.length - 1);
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.TopSubstation {
  background-color: #fff;
  .TopSubstation-box {
    display: flex;
    align-items: center;
    min-height: 38px;
    flex-wrap: wrap;
    border-bottom: 2px solid #e60012;
    padding: 0 16px;
  }
  .TopSubstation-def {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-around;
    flex-wrap: wrap;
    min-width: 255px;
  }
  a {
    // width: 45px;
    display: block;
    text-align: center;
    font-size: 14px;
  }
  .TopSubstation-more {
    padding: 0;
    color: #e60012;
  }
  .substation-more-box {
    width: 100vw;
    padding: 10px 16px;
    background: #f7f5e0;
    border-bottom: 2px solid #e60012;

    .substation-more-item {
      display: flex;
      .substation-label {
        margin-right: 16px;
      }
      a {
        width: 55px;
        text-align: left;
      }
    }
  }
  .substation-label {
    padding-left: 10px;
    width: 50px;
    text-align: center;
    font-size: 10px;
  }
}
</style>
